import { CLOSED_CONTENT_WIDTH as closedDrawerWidthHeight } from 'layout/MainLayout/components/Sidebar/constants';
import { closedMixin } from 'layout/MainLayout/components/Sidebar/utils';

import type { CSSObject, Theme } from '@mui/material/styles';

export const closedListItemMixin = (theme: Theme): CSSObject => ({
  width: closedDrawerWidthHeight,
  height: closedDrawerWidthHeight,
  marginBottom: theme.spacing(0.125),
  ...closedMixin({ theme }),
});
